export default __webpack_public_path__ + "static/media/external-lab-testing-icon.61f51247.svg";